<section class="navigation-bar">
  <div class="container" cdkOverlayOrigin #categoryMenuOrigin="cdkOverlayOrigin">
    @if (isShowCategoryButton()) {
      <app-product-category-menu [overlayOrigin]="categoryMenuOrigin" [categoryList]="(navigationCategories$ | async) ?? []" />
    }
    <app-search-bar [placeholder]="'common.form.placeholder.search_product' | translate" />
  </div>
</section>
